import { emptyLongDash } from './constants';

export const getStatusName = (status, t) => {
  switch (status) {
    case 'initialize':
      return t('Queued');
    case 'in_progress':
      return t('In progress');
    case 'completed':
      return t('Completed');
    case 'failed':
      return t('Failed');
    default:
      return emptyLongDash;
  }
};

export const getReportStatusName = (reportStatus, t) => {
  switch (reportStatus) {
    case 'completed':
      return t('Completed');
    case 'completed_with_warnings':
      return t('Completed with Warnings');
    case 'completed_with_errors':
      return t('Completed with Errors');
    case 'failed':
      return t('Failed');
    default:
      return null;
  }
};
